import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const arjIncrementEmbedRoute: InvariantJiraRoute = {
	name: 'software-plan-increment-embed',
	path: '/jira/plans/:planId/scenarios/:scenarioId/program/:incrementId/embed',
};
